export default {
	lang:'it',
	download:{
		"download01":"Finestre",
		"download02":"Mac",
		"download03":"iOS",
		"download04":"Android",
		"download05":"Scarica ora",
		"download":"scaricamento",
		"download2":"Mobile",
		"download3":"Scansiona il codice QR per scaricare iOS/Android",
		"download4":"Codice QR",
		"download5":"Finestre",
		"download6":"Supporta Windows 10 a 64 bit e versioni successive",
		"download7":"macOS",
		"download8":"Supporta MacOS 10.14 e versioni successive",
		"download9":"App Store",
		"download10":"Supporta MacOS 10.14 e versioni successive",
		"download11":"Android",
		"download12":"Supporta Android 10.14 e versioni successive",
	},
	home:{
		"home":"prima pagina",
		"XiaobeiBigModel":"Piccolo modello",
		"AIcapability":"intelligenza artificiale",
		"Solution":"Soluzione",
		"ProductCenter":"Prodotti",
		"MediaCenter":"Multimediale",
		"AboutUs":"chi siamo",
		"Login/Regis":"Accedi/Registrati",
		"home1":"Competenze di base",
		"home2":"Servizio clienti",
		"home3":"Numero di contatto",
		"home14":"L'empowerment dell'intelligenza artificiale, utilizzando hardware intelligente come vettore, fornisce funzionalità e servizi full-stack",
		"home15":"Algoritmo Jigsaw",
		"home16":"Riconoscimento OCR",
		"home17":"Intelligenza artificiale",
		"home18":"Riconoscimento vocale",
		"home19":"Dizionario autorevole",
		"home20":"Traduzione del testo",
		"home21":"Traduzione fotografica",
		"home22":"Domande e risposte generali",
		"home23":"Corsi video",
		"home24":"Xiaobei AI modello grande",
		"home25":"La tecnologia è la principale forza produttiva",
		"home26":"personale tecnico",
		"home27":"Investimenti in ricerca e sviluppo",
		"home28":"Numero di brevetti",
		"home29":"(Percentuale)",
		"home30":"(100 milioni di yuan)",
		"home31":"(articolo)",
		"home32":"Soluzione",
		"home33":"Per soddisfare le esigenze applicative di molteplici scenari quali uffici, istruzione e box auto, BeiBo fornisce ai clienti soluzioni complete basate sulle proprie capacità di ricerca e sviluppo e sui propri concetti di servizio.",
		"home34":"Soluzioni correlate",
		"home35":"Funzionalità del prodotto correlate",
		"home36":"Servizi full stack",
		"home37":"L'empowerment dell'intelligenza artificiale, utilizzando hardware intelligente come vettore, fornisce funzionalità e servizi full-stack",
		"home38":"Ricerca e sviluppo",
		"home39":"Produzione",
		"home40":"Gestione della qualità",
		"home41":"Assistenza post-vendita",
		"home42":"Team di ricerca e sviluppo professionale di software e hardware, con molti anni di esperienza in OCR, riconoscimento vocale, traduzione, intelligenza artificiale e capacità di ricerca e sviluppo di interazione uomo-computer.",
		"home43":"Fabbrica di origine, catena di fornitura stabile, produzione di processo intelligente rigorosa",
		"home44":"Gli ispettori di qualità controllano ogni passaggio e introducono il sistema di gestione ISO9001",
		"home45":"Creare team di assistenza post-vendita professionali in patria e all'estero per fornire risposte tempestive, soluzioni mirate e un servizio personalizzato.",
		"home46":"Certificazione",
		"home47":"Oltre 100 brevetti nazionali ed esteri",
		"home48":"Notizia",
		"home49":"Scopri le nostre ultime novità",
		"home50":"controlla i dettagli",
		"home51":"Partner",
		"home52":"Concentrarsi sul mercato dell'hardware per l'intelligenza artificiale e fornire servizi OEM/0DM professionali",
		"home53":"Consultazione di cooperazione",
		"home54":"Ufficio intelligente",
		"home55":"Istruzione intelligente",
		"home56":"Scatola per auto intelligente",
		"home57":"Riconoscimento vocale",
		"home58":"Algoritmo Jigsaw",
		"home59":"Riconoscimento OCR",
		"home60":"Sintesi vocale",
		"home61":"Traduzione del testo",
		"home62":"Traduzione dell'immagine",
		"home63":"Traduzione vocale",
		"home64":"Elaborazione del linguaggio naturale",
		"home571":"Riconoscimento OCR",
		"home581":"Riconoscimento vocale ",
		"home591":"Traduzione vocale",
		"home601":"Sintesi vocale",
		"home611":"Dizionario autorevole",
		"home621":"Corsi Generali",
		"home631":"Domande e risposte generali",
		"home641":"Elaborazione del linguaggio naturale",
		"home572":"Riconoscimento vocale",
		"home582":"Sintesi vocale ",
		"home592":"Traduzione vocale",
		"home602":"Elaborazione del linguaggio naturale",
		"home603":"Non più",
	},
	consult:{
		"tilte":"Vi forniremo con tutto il cuore una gamma completa di servizi di cooperazione aziendale",
		"subtilte":"Lascia i tuoi dati di contatto e ti contatteremo il prima possibile",
		"name":"Inserisci il tuo nome",
		"phone":"Inserisci il tuo numero di telefono",
		"mailbox":"Inserisci la tua email",
		"mailboxerr":"Errore nel formato dell'email",
		"company":"Inserisci la tua azienda",
		"desc":"Inserisci i tuoi requisiti",
		"but":"Conferma l'invio",
		"region":"Cina",
		"select":"Si prega di selezionare",
		"submitSuccess":"Invia con successo",
		"submitError":"Invio non riuscito",
	},
	ProDetails:{
		"ProDetails1":"Processo di personalizzazione",
		"ProDetails2":"Concentrarsi sul mercato dell'hardware per l'intelligenza artificiale e fornire servizi OEM/0DM professionali",
	},
	aiCapacity:{
		"aiMode1":"Capacità di intelligenza artificiale",
		"aiMode2":"Basandoci su tecnologie quali big data, knowledge graph, machine learning e linguistica, continuiamo a innovare e a concentrarci sulla ricerca delle tecnologie fondamentali dell'intelligenza artificiale e sull'implementazione di applicazioni hardware intelligenti.",
		"aiMode3":"Consultazione di cooperazione",
		"aiMode4":"Competenze di base",
		"aiMode5":"L'empowerment dell'intelligenza artificiale, utilizzando hardware intelligente come vettore, fornisce funzionalità e servizi full-stack",
		"aiMode6":"Algoritmo Jigsaw",
		"aiMode7":"Unisci piccole immagini frammentate in immagini più grandi per il riconoscimento, supportando oltre 50 lingue",
		"aiMode8":"Riconoscimento OCR",
		"aiMode9":"Estrarre testo tramite elaborazione delle immagini e tecnologia di riconoscimento di pattern. Supporta oltre 50 lingue.",
		"aiMode10":"Riconoscimento vocale",
		"aiMode11":"Riconosce con precisione l'audio lungo e breve in testo. Supporta oltre 130 lingue.",
		"aiMode12":"Sintesi vocale",
		"aiMode13":"Converti il testo in una voce umana naturale e fluente. Supporta oltre 130 lingue.",
		"aiMode14":"Traduzione del testo",
		"aiMode15":"Converti il testo dalla lingua di destinazione alla lingua specificata. Supporta oltre 130 lingue.",
		"aiMode16":"Traduzione dell'immagine",
		"aiMode17":"Riconoscimento e traduzione di testo di immagini. Supporta oltre 130 lingue.",
		"aiMode18":"Traduzione vocale",
		"aiMode19":"Riconosce e traduce con precisione audio lunghi e brevi. Supporta oltre 130 lingue.",
		"aiMode20":"Elaborazione del linguaggio naturale",
		"aiMode21":"Sulla base dei big data, della conoscenza e della tecnologia linguistica, è possibile realizzare applicazioni come la risposta alle domande e il dialogo",
		"aiMode22":"Autorità del dizionario",
		"aiMode23":"Collaborare attivamente con istituzioni autorevoli per fornire dizionari autentici come Oxford, Longman e varie lingue minoritarie",
		"aiMode24":"Corsi video",
		"aiMode25":"Corsi video completi, libri di testo aggiornati simultaneamente, adatti per anteprima e revisione",
		"aiMode26":"Domande e risposte generali",
		"aiMode27":"Rispondere alle domande e interpretare le domande in tutte le materie, imparare per analogia e migliorare l'efficienza dell'apprendimento",
		"aiMode28":"Xiaobei AI modello grande",
		"aiMode29":"Interazione multimodale",
		"aiMode30":"Interazione multimodale di testo, voce e video",
		"aiMode31":"Capacità di codifica",
		"aiMode32":"Generazione, interpretazione, debug, test del codice",
		"aiMode33":"Generazione di testo",
		"aiMode34":"Composizione, marketing, redazione di comunicati stampa, ecc.",
		"aiMode35":"Medicina generale",
		"aiMode36":"Impostazione delle domande e risoluzione dei problemi per tutte le materie",
		"aiMode37":"Comprensione linguistica",
		"aiMode38":"Estrazione astratta, controllo grammaticale, analisi del sentiment",
		"aiMode39":"Curiosità",
		"aiMode40":"Conoscenza della vita, del lavoro, della medicina e della storia",
		"aiMode41":"Ragionamento logico",
		"aiMode42":"Pensiero, scienza, ragionamento di buon senso",
		"aiMode43":"Multilingue",
		"aiMode44":"Supporta l'interazione in più di 100 lingue",
		"aiMode45":"Vantaggi tecnici",
		"aiMode46":"200 milioni di corpus accurati",
		"aiMode47":"Ampiamente utilizzato in uffici intelligenti, istruzione intelligente, smart car box",
		"aiMode48":"Tecnologia collaborativa globale",
		"aiMode49":"Latenza ultra bassa, sicura e stabile, pianificazione intelligente, collegamento stabile",
		"aiMode50":"Sistema di crittografia di sicurezza",
		"aiMode51":"Sistema di crittografia quadridimensionale cloud-pipe-end-data leader a livello internazionale, crittografia full-process",
	},
	aiMode:{
		"aiMode1":"Capacità di intelligenza artificiale",
		"aiMode2":"Basandoci su tecnologie quali big data, knowledge graph, machine learning e linguistica, continuiamo a innovare e a concentrarci sulla ricerca delle tecnologie fondamentali dell'intelligenza artificiale e sull'implementazione di applicazioni hardware intelligenti.",
		"aiMode3":"Consultazione di cooperazione",
		"aiMode4":"Competenze di base",
		"aiMode5":"L'empowerment dell'intelligenza artificiale, utilizzando hardware intelligente come vettore, fornisce funzionalità e servizi full-stack",
		"aiMode6":"Algoritmo Jigsaw",
		"aiMode7":"Unisci piccole immagini frammentate in immagini più grandi per il riconoscimento, supportando oltre 50 lingue",
		"aiMode8":"Riconoscimento OCR",
		"aiMode9":"Estrarre testo tramite elaborazione delle immagini e tecnologia di riconoscimento di pattern. Supporta oltre 50 lingue.",
		"aiMode10":"Riconoscimento vocale",
		"aiMode11":"Riconosce con precisione l'audio lungo e breve in testo. Supporta oltre 130 lingue.",
		"aiMode12":"Sintesi vocale",
		"aiMode13":"Converti il testo in una voce umana naturale e fluente. Supporta oltre 130 lingue.",
		"aiMode14":"Traduzione del testo",
		"aiMode15":"Converti il testo dalla lingua di destinazione alla lingua specificata. Supporta oltre 130 lingue.",
		"aiMode16":"Traduzione dell'immagine",
		"aiMode17":"Riconoscimento e traduzione di testo di immagini. Supporta oltre 130 lingue.",
		"aiMode18":"Traduzione vocale",
		"aiMode19":"Riconosce e traduce con precisione audio lunghi e brevi. Supporta oltre 130 lingue.",
		"aiMode20":"Elaborazione del linguaggio naturale",
		"aiMode21":"Sulla base dei big data, della conoscenza e della tecnologia linguistica, è possibile realizzare applicazioni come la risposta alle domande e il dialogo",
		"aiMode22":"Autorità del dizionario",
		"aiMode23":"Collaborare attivamente con istituzioni autorevoli per fornire dizionari autentici come Oxford, Longman e varie lingue minoritarie",
		"aiMode24":"Corsi video",
		"aiMode25":"Corsi video completi, libri di testo aggiornati simultaneamente, adatti per anteprima e revisione",
		"aiMode26":"Domande e risposte generali",
		"aiMode27":"Rispondere alle domande e interpretare le domande in tutte le materie, imparare per analogia e migliorare l'efficienza dell'apprendimento",
		"aiMode28":"Xiaobei AI modello grande",
		"aiMode29":"Interazione multimodale",
		"aiMode30":"Interazione multimodale di testo, voce e video",
		"aiMode31":"Capacità di codifica",
		"aiMode32":"Generazione, interpretazione, debug, test del codice",
		"aiMode33":"Generazione di testo",
		"aiMode34":"Redazione di saggi, marketing, comunicati stampa, ecc.",
		"aiMode35":"Medicina generale",
		"aiMode36":"Impostazione delle domande e risoluzione dei problemi per tutte le materie",
		"aiMode37":"Comprensione linguistica",
		"aiMode38":"Estrazione astratta, controllo grammaticale, analisi del sentiment",
		"aiMode39":"Curiosità",
		"aiMode40":"Conoscenza della vita, del lavoro, della medicina e della storia",
	},
	Product:{
		"Product1":"Centro prodotti",
		"Product2":"Prodotti intelligenti per ufficio, istruzione e veicoli, supportano l'ordinazione e la personalizzazione delle funzioni",
		"Product3":"Consultazione di cooperazione",
	},
	medium:{
		"medium1":"Centro multimediale",
		"medium2":"Le ultime novità di BeiBo, vedi qui",
		"medium3":"Consultazione di cooperazione",
	},
	about:{
		"about1":"Scopri di più su BeiBo",
		"about2":"Fornitore di soluzioni hardware intelligenti per ufficio, istruzione, box auto, ecc.",
		"about3":"Consultazione di cooperazione",
		"about4":"Profilo Aziendale",
		"about5":"Certificazione",
		"about6":"Oltre 100 brevetti nazionali ed esteri",
		"about7":"Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"about8":`Fondata nel 2015 e con sede a Shenzhen, il centro cinese della "produzione intelligente", BeiBo Intelligent è un'impresa nazionale high-tech, specializzata e innovativa, con una visione lungimirante e uno spirito innovativo.`,
		"about9":"L'azienda si concentra sul segmento verticale dell'intelligenza artificiale vocale e vanta solide capacità di ricerca e sviluppo in ambito hardware e software. Potenzia l'hardware AI esportando tecnologie AI come l'intelligenza artificiale vocale, la traduzione AI, l'OCR AI, l'interazione uomo-veicolo AI e il cloud AI. L'azienda sviluppa un proprio modello AI per la traduzione vocale, integra le più recenti tecnologie AI multimodali e AIGC e fornisce soluzioni AI vocali full-stack per clienti in diversi settori, basate sulla ricerca e sviluppo e sulla progettazione di piattaforme chip e soluzioni hardware. Nei settori dell'istruzione, della pubblica amministrazione, delle imprese e dell'esercito, l'azienda vanta soluzioni industriali consolidate; per quanto riguarda i consumatori, le vendite annuali di hardware AI come traduttori AI, registratori vocali AI, scanner AI e box per auto AI superano il milione di unità. L'azienda collabora con numerosi partner strategici in Giappone, Europa, Stati Uniti e altri paesi e regioni per aiutare le persone a superare le barriere linguistiche ed è un fornitore leader a livello mondiale di soluzioni AI vocali.",
		"about10":"",
	},
	footer:{
		"AboutUs":"chi siamo",
		"CollaborativeConsulting":"Consultazione di cooperazione",
		"Businesscooperation":"Cooperazione commerciale",
		"phone":"Inserisci il tuo numero di telefono",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"Tel. 0755 27189290",
		"address":"Stanza 201, Edificio F, Zona Industriale di Yuanfen, Comunità di Taoyuan, Via Dalang, Distretto di Longhua, Shenzhen",
		"copyright":"Copyright © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"Guangdong ICP n. 2024241358-1",
		"footer2":"Benvenuti alla registrazione",
		"footer3":"Hai già un account?",
		"footer4":"Effettua il login",
	},
	login:{
		"login1":"Accesso con password",
		"login2":"Accesso tramite SMS",
		"loginTab3":"Accesso e-mail",
		"login3":"Posta",
		"login4":"Password di accesso",
		"login5":"Numero di telefono",
		"login6":"Si prega di selezionare",
		"login7":"Codice di verifica mobile",
		"login8":"Login",
		"login9":"dimenticare la password",
		"login10":"registro",
		"login11":"Accedendo accetti",
		"login12":"Contratto di servizio",
		"login13":"politica sulla riservatezza",
		"login14":"Ottenere",
		"login15":"Cina",
		"login16":"Inserisci il tuo numero di conto",
		"login17":"Inserisci la tua password",
		"login18":"Accesso effettuato con successo!",
		"login19":"Inserisci il codice di verifica!",
		"login20":"Inviato con successo!",
		"login21":"E",
		"login22":"Disco cloud con registratore vocale",
		"login23":"La mia scrittura",
		"login24":"La mia conversazione",
		"login25":"Sicurezza dell'account",
		"login26":"Disconnettersi",
		"login27":"Recupera la password via email",
		"login28":"Posta",
		"login29":"Codice di verifica e-mail",
		"login30":"Imposta una password di accesso (6-16 caratteri)",
		"login31":"Reinserisci la tua password di accesso",
		"login32":"invia",
		"login33":"Torna al login",
		"login34":"Modifica riuscita!",
	},
	register:{
		"register1":"Numero di telefono",
		"register2":"Inserisci il tuo numero di telefono",
		"register3":"Si prega di selezionare",
		"register4":"Codice di verifica mobile",
		"register5":"Imposta password",
		"register6":"Inserisci il codice di verifica",
		"register7":"6-16 caratteri",
		"register8":"Conferma della password",
		"register9":"Posta",
		"register10":"Inserisci il tuo indirizzo email",
		"register11":"Codice di verifica e-mail",
		"register12":"Inserisci il codice di verifica",
		"register13":"Ho letto e accetto",
		"register14":"Si prega di leggere e spuntare la casella che accetta l'accordo",
		"register15":"Il formato del numero di telefono non è corretto/il numero di telefono è stato registrato",
		"register16":"Errore del codice di verifica mobile",
		"register17":"Inserisci il tuo indirizzo email / Il formato dell'indirizzo email non è corretto",
		"register18":"Errore nel formato dell'email",
		"register19":"Errore nel codice di verifica dell'email",
		"register20":"Si prega di impostare la password su 6-16 caratteri",
		"register21":"Errore nel formato della password",
		"register22":"Le password inserite due volte non corrispondono. Inseriscile di nuovo.",
		"register23":"Inserisci la tua password",
		"register24":"Registrazione avvenuta con successo!",
		"register25":"Errore nel codice di verifica",
	},
	recorder:{
		"recorder1":"Disco cloud con registratore vocale",
		"recorder2":"Capacità dello spazio cloud",
		"recorder3":"documento",
		"recorder331":"Cestino",
		"recorder332":"Cancella tutto",
		"recorder4":"nome",
		"recorder5":"Durata audio",
		"recorder6":"Dimensione del file",
		"recorder7":"Tempo di creazione",
		"recorder8":"operare",
		"recorder9":"Descrizione dello spazio cloud",
		"recorder10":"documento",
		"recorder11":"File OCR",
		"recorder12":"1. A cosa serve lo spazio cloud?",
		"recorder13":"Dopo aver registrato sul registratore, puoi caricare i file audio e la trascrizione sullo spazio cloud. Anche se il registratore non è con te, puoi accedere allo spazio cloud per visualizzare l'audio.",
		"recorder14":"2. Come caricare sullo spazio cloud?",
		"recorder15":"Vai su [I miei file] sul registratore, seleziona il file di destinazione e tieni premuto per visualizzare le opzioni, quindi fai clic su Carica per caricare il file sullo spazio cloud.",
		"recorder16":"3. Come visualizzare/gestire i file dello spazio cloud?",
		"recorder17":"Accedi al sito web ufficiale di BeiBo, seleziona My-Recorder Cloud Disk e potrai visualizzare i file del registratore caricati. Puoi selezionare il file di destinazione da scaricare, eliminare, ecc. Puoi liberare spazio di archiviazione nel cloud eliminando i file dello spazio cloud!",
		"recorder18":"Non trascritto",
		"recorder19":"Visualizza il riepilogo",
		"recorder20":"Oratore",
		"recorder21":"Modifica il nome dell'oratore",
		"recorder22":"Sicuro",
		"recorder23":"scaricamento",
		"recorder24":"Scarica il contenuto:",
		"recorder25":"Impostazioni di download:",
		"recorder26":"Mostra relatore",
		"recorder27":"Cancellare",
		"recorder28":"Condivisione dei link",
		"recorder29":"Chiunque riceva il link può accedervi. È solo per la lettura e il link è valido per 7 giorni.",
		"recorder30":"Copia il collegamento",
		"recorder31":"Scansiona e visualizza rapidamente",
		"recorder32":"Organizzazione intelligente",
		"recorder33":"Distinguere tra i parlanti",
		"recorder34":"Distinguere in modo intelligente il testo trascritto in base al ruolo del parlante",
		"recorder35":"Regolarizzazione intelligente del linguaggio parlato",
		"recorder36":"Filtra automaticamente le particelle modali, le parole ripetute e le parole in pausa",
		"recorder37":"Filtraggio non vocale",
		"recorder38":"Salta automaticamente l'audio senza voce o rumore durante la riproduzione",
		"recorder39":"Si prega di selezionare",
		"recorder40":"documento",
		"recorder41":"Audio",
		"recorder42":"Documenti + Audio",
		"recorder43":"suggerimento",
		"recorder44":"Questa operazione eliminerà dei file. Vuoi continuare?",
		"recorder441":"Questa operazione eliminerà tutti i file. Vuoi continuare?",
		"recorder45":"Sicuro",
		"recorder46":"Cancellare",
		"recorder47":"Eliminato con successo!",
		"recorder48":"Non cancellato",
		"recorder49":"Nessun tag ancora",
		"recorder50":"Risparmio...",
		"recorder51":"Cestino",
	},
	personal:{
		"personal1":"Impostazioni dell'account",
		"personal2":"informazioni personali",
		"personal3":"avatar",
		"personal4":"Carica file",
		"personal5":"Supporta gli stili JPG, JPEG, GIF, PNG, supporta immagini entro 2M",
		"personal6":"soprannome",
		"personal7":"Inserisci il tuo nickname",
		"personal8":"genere",
		"personal9":"signori",
		"personal10":"Mancare",
		"personal11":"Riservatezza",
		"personal12":"Compleanno",
		"personal13":"Seleziona la tua data di nascita",
		"personal14":"Professione",
		"personal15":"Seleziona la tua professione",
		"personal16":"Inserisci la tua professione (facoltativo)",
		"personal17":"nazione",
		"personal18":"Seleziona il tuo paese",
		"personal19":"Mantenere",
		"personal20":"informazioni personali",
		"personal21":"Sicurezza dell'account",
		"personal22":"Supporta solo immagini entro 2M",
		"personal23":"Caricamento effettuato con successo!",
		"personal24":"Modifica riuscita!",
		"personal25":"Sicurezza dell'account",
		"personal26":"Password di accesso",
		"personal27":"Rivedere",
		"personal28":"E-mail",
		"personal29":"sostituire",
		"personal30":"Cancellazione dell'account",
		"personal32":"Sei sicuro di voler cancellare il tuo account?",
		"personal33":"Dopo aver effettuato il logout, tutti i contenuti del tuo account verranno cancellati, quindi procedi con cautela.",
		"personal34":"Cancellare",
		"personal35":"Sicuro",
		"personal36":"Autenticazione",
		"personal37":"Per confermare che sei tu a farlo, completa la verifica dell'identità tramite il codice di verifica e-mail",
		"personal38":"Posta",
		"personal39":"Codice di verifica",
		"personal40":"Inserisci il codice di verifica",
		"personal41":"Passo successivo",
		"personal42":"Imposta una nuova casella di posta",
		"personal43":"Posta",
		"personal44":"Inserisci un nuovo indirizzo email",
		"personal45":"Codice di verifica",
		"personal46":"Inserisci il codice di verifica",
		"personal47":"Sicuro",
		"personal48":"Imposta una nuova password di accesso",
		"personal49":"Nuova password di accesso",
		"personal50":"Inserisci la nuova password",
		"personal51":"Conferma nuova password",
		"personal52":"Inserisci nuovamente la tua nuova password",
		"personal53":"Sicuro",
		"personal54":"Ottenere",
		"personal55":"Errore nel formato dell'email",
		"personal56":"Sostituzione riuscita!",
		"personal57":"Si prega di impostare la password su 6-16 caratteri",
		"personal58":"Le password inserite due volte non corrispondono",
		"personal59":"Modifica riuscita!",
		"personal60":"Disconnessione avvenuta con successo!",
	}
}